import { PageConfig } from "../page-configs";
import { AlertId, getAlert } from "../alert";
import { DISCLAIMER } from "../../../global/variables";
import { getWelcomeText } from "../welcome";
import { INKASSO_BUTTONS } from "../../feature-buttons";

export const pageConfigInkasso: PageConfig = {
    header: "Digitaler Assistent",
    alert: getAlert(AlertId.InkassoAskQuestions),
    welcome: {
        text: getWelcomeText("INKASSO"),
        disclaimer: DISCLAIMER,
        buttons: INKASSO_BUTTONS,
    },
};
